import R from 'ramda';

export const generateChannelAdvisorWidgetUrl = ({ selectedSKU, url, caPid }) =>
  `${url}?pid=${caPid}&modelname=${selectedSKU}`;

export const validateSku = R.replace(/^0*/, '');
